import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 添加Google Fonts
const link1 = document.createElement('link');
link1.rel = 'stylesheet';
link1.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500;600;700&display=swap';
document.head.appendChild(link1);  // 修复这里：移除空格

// 添加Roboto Mono字体
const link2 = document.createElement('link');
link2.rel = 'stylesheet';
link2.href = 'https://fonts.googleapis.com/css2? family=Roboto+Mono&display=swap';
document.head.appendChild(link2);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
